import { Card } from '@repo/shadcn';

import { CsvExportIcon, PdfExportIcon } from '@components/icons';
import { DataTable } from '@components/ui/data.table/data-table';
import { SectionError } from '@components/ui/error';
import { SectionLoader } from '@components/ui/loader';
import PaginationComponent from '@components/ui/pagination';

import { HeaderBreadcrumb } from '@/components/ui';
import { DEFAULT_PAGE_LIMIT, Route } from '@/constants';
import { useUrlPagination } from '@/hooks';
import { expenseReportColumns } from '@/modules/reports/expense/column';
import { useExpenseReport } from '@/modules/reports/expense/expense-report.hook';

export const ReportExpense = () => {
    const { page, setCurrentPage } = useUrlPagination();

    const {
        data,
        isLoading,
        isError,
        error,
        isFetching,
        handleExportToCSV,
        handleExportToPdf,
    } = useExpenseReport();

    if (isLoading) {
        return <SectionLoader />;
    }

    if (isError) {
        return <SectionError error={error} fallbackPath={Route.DASHBOARD} />;
    }
    const renderTable = () => {
        if (isError) {
            return <div>Something went wrong</div>;
        }

        return (
            <>
                <DataTable
                    isLoading={isLoading || isFetching}
                    data={data?.data || []}
                    columns={expenseReportColumns}
                />
                <p className="mt-3 flex w-full items-center px-4 text-right font-semibold">
                    Total Found : {data?.pagination?.total_items}
                </p>
                <PaginationComponent
                    showTotalItems
                    totalItems={data?.pagination?.total_items || 0}
                    itemsPerPage={data?.pagination?.limit || DEFAULT_PAGE_LIMIT}
                    initialPage={page}
                    onPageChange={(p) => {
                        setCurrentPage(p);
                    }}
                />
            </>
        );
    };

    return (
        <Card className={'space-y-4 p-4'}>
            <div className={'flex items-start justify-between'}>
                <HeaderBreadcrumb
                    showHomeLink={true}
                    items={[{ label: 'Reports' }, { label: 'Expense Reports' }]}
                />
                <div className={'flex items-center gap-4'}>
                    <div className={'flex items-center gap-4'}>
                        <button
                            type={'button'}
                            className={'scale-[1.2]'}
                            onClick={handleExportToPdf}
                        >
                            <PdfExportIcon />
                        </button>
                        <button
                            type={'button'}
                            className={''}
                            onClick={handleExportToCSV}
                        >
                            <CsvExportIcon />
                        </button>
                    </div>
                </div>
            </div>

            <h2 className={'text-xl font-medium'}>Expense Reports</h2>

            <div>Filters --- Search </div>

            <Card>{renderTable()}</Card>
        </Card>
    );
};

ReportExpense.displayName = 'ReportExpense';
